// 공통요소
import './assets/css/base/global.scss';
import { getListData, mainFn } from './js/components/header';

document.addEventListener('DOMContentLoaded', async () => {
  getListData();
  const { listHandler } = mainFn();
  listHandler();
});
